<template>
	<v-sheet color="transparent">
		<h2 class="cn-font grey--text mb-5">Dashboard</h2>
	<!-- 	<p>Im Dashboard finden Sie einen Überblick zu den Reifegradkennzahlen, die aus Ihren Angaben automatisch abgeleitet werden.<br/> Die Spitzenkennzahlen des KAZG geben die Digitale Reife Ihrer Einrichtung als relativen Prozentwert aus 100% und als Stufe in einer 5-stufigen Reifegradhierarchie an.<br/> Als Referenzwert für den internationalen Vergleich wird die EMRAM-Stufe näherungsweise abgeleitet und dargestellt. Wichtig: EMRAM-Stufe und KAZG Stufe sind nicht äquivalent, da im KAZG wesentlich mehr Kriterien berücksichtigt werden!<br/> Unter den Spitzenkennzahlen finden Sie eine Aufteilung nach struktur-, prozess- und ergebnisbezogener Reife, jeweils weiter untergliedert nach klinischem Anwendungsfeld, Informationsmanagement und organisatorischem Umfeld.</p>	 -->
		<v-row>
			<v-col cols="12" md="8">
				<v-card class="pa- mb-2" color="white">
					<v-card-title>Reifegrad nach KHZG</v-card-title>
					<v-card-text>
						<v-row>
							<v-col cols="12" md="6">
								Spitzenkennzahl der Digitalen Reife für das Haus
								<v-list-item>
									<v-list-item-icon>
										<v-icon x-large>mdi-hospital-building</v-icon> 
									</v-list-item-icon>
									<v-list-item-content>
									<v-list-item-title>
										Klinikum St. Annegret		
									</v-list-item-title>
									<v-list-item-subtitle>
									Vor dem Platze 29-35<br/>	
									12344 Großdorf 
									</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<p class="caption">Stand 30.9.2020</p>
								<v-simple-table dense class="mt-5 mb-7">
							
									<tbody>
										<tr v-for="(r, i) in org_info" :key="i">
											<td>{{r.item}}</td>
											<td>{{r.n}}</td>
										</tr>
									</tbody>
								</v-simple-table>
								<h4 class="mt-5">Wichtigste Abteilungen</h4>
								<p>Innere Medizin II, Kardiologie, Angiologie<br/>
								Innere Medizin I, Gastroenterologie<br/>
								Gynäkologie, Geburtshilfe<br/>
								Chirurgie II, Unfallchirurgie</p>
							</v-col>
							<v-col cols="12" md="6">
								<ScoreScale class="mr-1" :score="scores.total"></ScoreScale>
								<ReferenceScores class="mb-5"></ReferenceScores>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-img max-width="90" src="@/assets/images/logo.png"/>
						<v-spacer></v-spacer>
						<ResultsButtons></ResultsButtons>
					</v-card-actions>
				</v-card>
				<p class="text-right mt-3 mb-4">
					<v-btn class="mr-2" small rounded color="primary" text>Berechnungsmethode</v-btn>
					<v-btn class="mr-2" small rounded color="primary" text>Interpretation</v-btn>
					<v-btn class="mr-2" small rounded color="primary" text>Hilfe</v-btn>
				</p>
			</v-col>
			<v-col cols="12" md="4">
				<v-card class="pa-2">
					<v-card-title>Info</v-card-title>
					<v-card-text>
						<v-simple-table >
							<thead>
								<tr>
									<th colspan="2">Reifegradstufe</th>
									<th>Relativer Reifegrad </th>
								</tr>
							</thead>
							<tbody style="word-break: break-all">
								<tr>
									<td>
										<v-chip dark color="green">5</v-chip>
									</td>
									<td>76% - 100% </td>
									<td>Voll Erreicht </td>
								</tr>
								<tr>
									<td>
										<v-chip dark color="green lighten-1">4</v-chip>
									</td>
										<td>51% - 75% </td>
										<td>Überwiegend erreicht
									</td>
								</tr>
								<tr>
									<td>
										<v-chip dark color="yellow">3</v-chip>
									</td>
									<td>26% - 50% </td>
									<td>Teilweise Erreicht</td>
								</tr>
								<tr>
									<td>
										<v-chip dark color="orange">2</v-chip>
									</td>
									<td>1% - 25% </td>
									<td>Überwiegend nicht erreicht</td>
								</tr>
								<tr>
									<td>
										<v-chip dark color="red">1</v-chip>
									</td>
									<td>0% </td>
									<td> Nicht Erreicht	</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="4" v-for="theme in themes" :key="theme">
				<v-card height="100%">
					<v-card-title>{{prettyPrint(theme)}}</v-card-title>
					<v-card-text style="margin-bottom: 30px;">
						<v-row>
							<v-col cols="6" md="6">
								<p>{{captions[theme]}}</p>
							</v-col>
							<v-col cols="6" md="6">
								<v-card flat dark height="120px" class="mb-2" :color="scoreColor(scores[theme])">
									<p class="text-center text-h6 text-sm-h3 mb-0 pt-10 pb-7">
										{{scores[theme]}}%
									</p>
								</v-card>
							</v-col>
						</v-row>	
						<v-row>				
							<v-expansion-panels flat hide-action >
								<v-expansion-panel v-for="(subtheme, i) in content[theme]" :key="theme +'_'+ i">
									<v-expansion-panel-header hide-actions>
									<v-row> 
										<v-col cols="6" class="pb-0 pt-2">
											<h5>{{subtheme.heading}}
												<v-icon>  mdi-chevron-down </v-icon>
											</h5>
										</v-col>
										<v-col  cols="6" >
											<v-card  flat dark :color="scoreColor(subthemeScores[theme][i])" class="mb-2">
												<p class="text-center  pa-2">
													{{subthemeScores[theme][i]}}%
												</p>
											</v-card>
										</v-col>
									</v-row>
									</v-expansion-panel-header>
									<v-expansion-panel-content>
										<div v-html="subtheme.html"></div>
									</v-expansion-panel-content>
									</v-expansion-panel>
							</v-expansion-panels>
						</v-row>
							
					</v-card-text>
					<v-card-actions style="position: absolute; bottom: 0">
						<v-spacer></v-spacer>
						<ResultsButtons></ResultsButtons>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import AboutResults from "@/components/assessment/results/AboutResults"
	import ReferenceScores from "@/components/assessment/results/ReferenceScores"
	import ResultsButtons from "@/components/assessment/results/ResultsButtons"
	import ScoreScale from "@/components/assessment/results/ScoreScale"
	export default {
		name: "Results", 
		props: {
			
		},
		data: () => {
			return {
				expand: [],
				headings: {
					"Struktur": "Lorem Ipsum",
					"Prozess": "Aenean pellentesque",  
					"Ergebnis": "Proin vitae"
				},
				org_info: [
					{item: "Vollstationäre Fälle", n: "17.342"},
					{item: "Ambulante Fälle", n: "25.876"},
					{item: "Teilstationäre Fälle", n: "1.352"},
					{item: "Betten", n: "435"},
					{item: "Ärzte", n: "205"},
					{item: "Pflegekräfte", n: "397"}
				],
				captions: {
					"Struktur": "Digitale Fähigkeit und Verfügbarkeit.",
					"Prozess": "Digitale Nutzung und Nutzenoptimierung.",  
					"Ergebnis": "Digitale Nutzenstiftung und Nutzen."
				},
				content: {
					Prozess: [
						{
							heading: "Klinisches Anwendungsfeld",
							html: "<p>Diese Kennzahl bewertet, in welchem Umfang Informationstechnologie zur Unterstützung medizinischer, pflegerischer, therapeutischer und administrativer Prozesse genutzt wird.</p><ul><li>Aufnahme, Überleitung, Entlassung, insbesondere Kommunikation mit externen Leistungserbringern und Patienten </li><li>Notfallversorgung (nach §19 (1) KHZG) </li><li>Leistungsanforderung, -durchführung und Ergebnisrückmeldung (nach §19 (6) KHZG) </li><li>Medikation und AMTS (nach §19 (5) KHZG) </li><li>OP (Planung, Vorbereitung, Dokumentation, Bericht) </li><li>Dokumentation von Pflege- und Behandlungsleistungen (nach §19 (3) KHZG) </li><li>Querschnitts- und Versorgungsprozesse (z.B. Abrechnung, Belegung, Material, Personal) </li></ul>"
						},
						{						
							heading: "Informationsmanagement",
							html: "<p>In dieser Kennzahl wird bewertet, inwiefern formalisierte und regelmäßig durchgeführte Informationsmanagementaktivitäten auf strategischer, taktischer und operativer Ebene die Entwicklung und nachhaltige Umsetzung digitaler Reife (einer Digitalisierungsstrategie) fördern. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li>IT-Projektportfolio- & Innovations-Management</li> <li>Systemspezifikation, -auswahl und Implementierung</li> <li>Anwenderschulung, Help-Desk, Problemlösung </li> <li>Wartung, Instandhaltung, Disaster Recovery</li> <li>Strategisches IT-Monitoring & Evaluation</li> <li>Risikomanagement (nach §19 (10) KHZG)</li></ul>",
						},
						{
							heading: "Organisatorisches Umfeld",
							html: "<p>In dieser Kennzahl wird bewertet, inwiefern partizipative und innovationsfördernde Aktivitäten im organisatorischen Kontext eine innovationfreundliche Organisationskultur im Sinne digitaler Reife fördern. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul> <li>Partizipative Aktivitäten bspw. bei der Initiierung neuer IT-Projekte, der Spezifizierung, Auswahl und Implementierung neuer IT-Anwendungen</li> <li>Aktive Vermittlung zw. IT und Fachbereichen</li><li>Proaktiver Austausch von IT-Erfahrungen</li><li>Innovative Datenanalysen, Data Mining für Forschung und Controlling</li></ul>"

						}
					],

					Ergebnis: [
						{
							heading: "Klinisches Anwendungsfeld",
							html: "<p>In dieser Kennzahl wird bewertet, inwiefern die genutzten Informationssysteme von den Anwendern vor dem Hintergrund der einrichtungs- und bereichsspezifischen Erfordernisse als nützlich und nutzenstiftend eingeschätzt werden. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li> Eingeschätzte Nützlichkeit / Nutzenerschließung, insbesondere Verbesserung der Patientenversorgung und Patientensicherheit (nach §19 KHZG)</li></ul>"
						},
						{						
							heading: "Informationsmanagement",
							html: "<p>In dieser Kennzahl wird bewertet, inwiefern ein sicheres, stets innovatives (agiles) und performantes Informationssystem besteht, das auf den einrichtungsspezifischen Bedarf ausgerichtet ist.</p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li>Agilität, Anpassungsfähigkeit </li><li>Anwenderorientierung</li><li>Business Continuity</li><li>Informationssicherheit</li><li>Serviceleistung der IT</li><li>Wirtschaftlichkeit & Erfolg digitaler Projekte</li></ul>",
						},
						{
							heading: "Organisatorisches Umfeld",
							html: "<p>In dieser Kennzahl wird bewertet, inwiefern Nutzen für die Organisation nachweislich realisiert werden und inwiefern eine ausgeprägte Innovationskultur besteht, die die Entwicklung und nachhaltige Umsetzung digitaler Reife fördert. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li>Nachweisbare Innovationskultur</li><li>Strategisches Alignment</li><li>Business Intelligence</li><li>Lernende Organisation</li><li>realisierte Nutzen für die Organisation (Zeit, Geld, Sicherheit)</li></ul>"

						}
					],					
					Struktur: [
						{ 
							heading: "Klinisches Anwendungsfeld",
							html: "<p>In dieser Kennzahl wird die Reife technischer Ressourcen und struktureller Rahmenbedingungen zusammengefasst, die medizinische, pflegerische, therapeutische und administrative Prozesse unterstützen, um- oder neu gestalten. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li>Interoperabilität, Schnittstellen, Standards</li><li>Mobiler Datenzugriff</li><li>Sektorenübergreifende Vernetzung</li><li>Telemedizin (nach §19 (9) KHZG)</li><li>Patientenportale (nach §19 (2) KHZG)</li><li>Cloud-Computing-Systeme (nach §19 (7) KHZG)</li><li>Unterstütze</li>nde IT-Funktionen, Hardware und Peripherie (z.B. Identifikation, klinische Entscheidungsunterstützungssysteme nach §19 (4) KHZG)</li></ul>"
						}, 
						{
							heading: "Informationsmanagement", 
							html: "<p>In dieser Kennzahl wird die Reife von Ressourcen, Tools, Programmen, sowie institutionalisierten Funktionen und formalen Regelwerken bewertet, die eine professionelle Durchführung von Informationsmanagement-Aktivitäten ermöglichen. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li>IT-Governance</li><li>IT-Budget</li><li>IT-Personal</li><li>Nutzung von IM-Tools</li><li>Informationssicherheit / IT-Compliance (nach §19 (10) KHZG)</li></ul>"
						},
						{
							heading: "Organisatorisches Umfeld", 
							html: "<p>In dieser Kennzahl wird die Reife von Ressourcen, Tools und Programmen bewertet, die in Bezug auf digitale Reife partizipative und innovationsfördernde Aktivitäten im organisatorischen Kontext fördern sowie die Einhaltung regulatorischer Anforderungen ermöglichen. </p><p>Berücksichtigte Themenbereiche sind u.a.: </p><ul><li>Vorschlagswesen & Austausch zwischen Klinikern und IT</li><li>Data Science-Funktionen und -strukturen</li><li>Externe und interne Richtlinien / Gesetzgebung</li></ul>"
						}
					]
				},
				themes: ["Struktur", "Prozess", "Ergebnis" ],
				sections: [
					{name: "nEvXC6LiodUp", theme: "Struktur", title: "Sektorenübergreifende Vernetzung"},
					{name: "O1buT5eqf9G7", theme: "Struktur", title: "Informationssicherheit / IT-Compliance"},
					{name: "z2Clmkrc0CqM", theme: "Prozess", title: "Medikationsverordnung & Entscheidungsunterstützung"},
					{name: "GHv7JhvYAVnY", theme: "Ergebnis", title: "Klinisches Anwendungsfeld"},
					{name: "HfQeYi5oDo1V", theme: "Ergebnis", title: "Informationsmanagement"},
					{name: "hdRivB3HiKS3", theme: "Ergebnis", title: "Organisatorisches Umfeld"},
				],
			}
		},
		components: {
			// AboutResults,
			ReferenceScores,
			ResultsButtons,
			ScoreScale
		},
		computed: {
			...Vuex.mapState({
				settings: state => state.assessmentSettings, 
				assessments: state => state.assessments || []
			}),
			assessment() {
				if( !this.assessments ){
					return {}
				}
				return this.assessments[0];
			}, 
			scores() {
				return this.assessment.scores || [];
			}, 
			subthemeScores(){
				var obj = {}
				this.themes.forEach( t => {
					obj[t] = this.sections.filter( a => a.theme == t).map( s => this.scores[s.name] )
				})
				for( var key in obj) {
					var avg = this.average(obj[key]);
					for( var i = 0; i < 3; i++ ){
						if( typeof obj[key][i] == 'undefined' ){
							obj[key][i] = avg;
						}
					}
				}
				return obj;


			}
		},
		watch: {
			settings: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue ){
					if( newValue && !oldValue ){
						if( this.$store.hasModule("assessmentSettings")  ){
							this.$store.dispatch("assessmentSettings/getSettings").then( ( ) => {
							})
						}
						if( this.$store.hasModule("surveys")  ){
							this.$store.dispatch("surveys/getAll").then( ( ) => {
							})
						}
					}
					
				}
			}
		},
		methods: {
			color(score){
				if( score > 89 ){
					return "green"
				}
				if( score > 70 ){
					return "green lighten-3"
				}
				if( score > 30 ){
					return "orange"
				}
				return "red";
			},
		}
		// created(){
			
		// }

	}
</script>